import styled from "styled-components";
export default {
    ItemsWrapper: styled.ul `
    && {
      position: relative;
      display: block;
      top: 0;
      z-index: 0;
      width: 100%;
      box-shadow: none;
      margin-top: 0;
    }

    & > li:not(.active) > .dropdown-menu-item:focus:not(:hover) {
      background-color: transparent;
    }

    & > li.inactive > .dropdown-menu-item {
      color: ${({ theme }) => theme["gray-500"]};
      cursor: default;
      pointer-events: none;
      &:hover,
      &:focus {
        color: ${({ theme }) => theme["gray-500"]};
        background-color: transparent;
      }
    }
  `
};
